module.exports = __webpack_public_path__ + "media/images/shared/class-display-708db6dbd0c9aeb97ea5dfab7d8808f2.svg";